import { createContext, ReactNode, useContext, useMemo } from 'react';
import { soundPlayer, SoundPlayer } from './play-sound';
import { AudibleAlerts, audibleAlerts, createAudibleAlerts } from './audible-alerts';

/** Component tests override the sound player to see which sounds the alerts would play. */
export type PlaySoundContextType = SoundPlayer;

const AudibleAlertsContext = createContext<AudibleAlerts | undefined>(undefined);

export function PlaySoundProvider({
    value,
    children,
}: {
    value?: Partial<PlaySoundContextType>;
    children: ReactNode;
}) {
    const alerts = useMemo(
        function createAlertsForPlayer() {
            return value ? createAudibleAlerts({ ...soundPlayer, ...value }) : audibleAlerts;
        },
        [value]
    );
    return <AudibleAlertsContext.Provider value={alerts}>{children}</AudibleAlertsContext.Provider>;
}

/** Stable for the life of the provider, so it is safe in effect dependencies. */
export function useAudibleAlerts(): AudibleAlerts {
    const value = useContext(AudibleAlertsContext);
    if (!value) {
        throw new Error('Unexpectedly did not find AudibleAlertsContext value');
    }
    return value;
}
